import axios from "axios";

const URL = process.env.REACT_APP_API_BASE_PROD_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002'; // Fallback to localhost if not set
// User API functions   

export async function createCase(payload, token) {
  try {
    if (!payload || !payload.patientId) {
      throw new Error("patientId is required to create a case");
    }

    const response = await axios.post(`${URL}/cases`, payload);

    if (response.status === 201 || response.status === 200) {
      // Backend returns { insertedId, insertedCase } in the example;
      // fall back to response.data for flexibility.
      return response.data.insertedCase || response.data;
    } else {
      throw new Error(response.data?.error || "Failed to create case");
    }
  } catch (error) {
    console.error("❌ Error creating case:", error?.message || error);
    throw error;
  }
}

export async function getCasesByPatientId(patientId, token) {
  try {
    if (!patientId) {
      throw new Error("Patient ID is required");
    }

    const response = await axios.post(
      `${URL}/cases/by-patient`,
      { patientId }
    );

    if (response.status === 200) {
      return response || [];
    } else {
      throw new Error(response.data?.error || "Failed to fetch cases");
    }
  } catch (error) {
    console.error("❌ Error fetching cases:", error?.message || error);
    throw error;
  }
}

export async function updateCaseById(caseId, updates = {}, token) {
  try {
    if (!caseId) {
      throw new Error("caseId is required to update a case");
    }

    const response = await axios.put(
      `${URL}/cases/${caseId}`,
      updates
    );

    if (response.status === 200) {
      return response.data; // e.g. { success: true, updatedCount: 1 }
    } else {
      throw new Error(response.data?.error || "Failed to update case");
    }
  } catch (error) {
    console.error("❌ Error updating case:", error?.message || error);
    throw error;
  }
}